import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import { Button, type ButtonBaseProps } from '../../button/Button';

/**
 * DropdownMenu用の操作メニュートリガーボタン（EllipsisVerticalIcon アイコン）
 *
 * DropdownMenuTrigger(asChild) が ref やイベントハンドラを children にマージするため、
 * rest props を Button に透過させる必要がある
 */
type DropdownMenuIconButtonProps = Omit<ButtonBaseProps, 'children'> & {
  'aria-label': string;
};

export const DropdownMenuIconButton = ({
  variant = 'non-outline',
  size = 'icon',
  ...props
}: DropdownMenuIconButtonProps) => (
  <Button variant={variant} size={size} {...props}>
    <EllipsisVerticalIcon className="h-4 w-4" />
  </Button>
);
